module.exports = __webpack_public_path__ + "img/verificationEmailIcon.3f0a0663.png";